import React from "react";

import SmartImage from "../../../components/SmartImage";
import { formatKm } from "../../detail/deliverability";
import { formatAmount } from "../accessoryMoney";

const DOT = "/assets/icons/accessories/dot.svg";

const AccessoryCard = ({ card, onOpen }) => {
  const badge = card.notice
    ? card.notice.badge
    : card.inStock === false
    ? "Out of stock"
    : null;

  const priceValue = card.hasPriceRange ? card.priceFrom : card.price;

  const place = card.supplierName || card.categoryTitle || "";
  const distance = Number.isFinite(card.distanceKm)
    ? formatKm(card.distanceKm)
    : "";

  return (
    <li className="acc-card">
      <button
        type="button"
        className="acc-card-button"
        onClick={() => onOpen(card)}
        aria-describedby={card.notice ? `acc-notice-${card.id}` : undefined}
      >
        <span className={`acc-card-media${card.notice ? " is-dimmed" : ""}`}>
          <SmartImage src={card.imageUrl} alt="" aspectRatio="286 / 230" />

          {badge && (
            <span
              className={`acc-badge${card.notice ? " acc-badge-blocked" : ""}`}
              id={card.notice ? `acc-notice-${card.id}` : undefined}
            >
              {badge}
            </span>
          )}
        </span>

        <span className="acc-card-body">
          <span className="acc-card-name">{card.name}</span>

          {card.description && (
            <span className="acc-card-desc">{card.description}</span>
          )}

          <span className="acc-card-facts">
            {(place || distance) && (
              <span className="acc-card-meta">
                {place && <b>{place}</b>}

                {place && distance && (
                  <img src={DOT} alt="" aria-hidden="true" />
                )}

                {distance && <b>{distance}</b>}
              </span>
            )}

            <span className="acc-card-price">
              {card.hasPriceRange && <i>From</i>}

              {!card.hasPriceRange && card.hasDiscount && (
                <s>
                  <span className="sy-visually-hidden">Was </span>
                  {formatAmount(card.originalPrice, card.currency)}
                </s>
              )}

              <b>{formatAmount(priceValue, card.currency)}</b>
            </span>
          </span>
        </span>
      </button>
    </li>
  );
};

export const supplierDistanceLabel = (card) =>
  Number.isFinite(card?.distanceKm) ? formatKm(card.distanceKm) : "";

export default React.memo(AccessoryCard);
